import { render } from "./OrgView.vue?vue&type=template&id=0b181766&scoped=true"
import script from "./OrgView.vue?vue&type=script&lang=js"
export * from "./OrgView.vue?vue&type=script&lang=js"

import "./OrgView.vue?vue&type=style&index=0&id=0b181766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b181766"]])

export default __exports__